// extracted by mini-css-extract-plugin
export var box = "_6c-1";
export var checked = "_6c-2";
export var descriptionSpacer = "_6c-9";
export var disabled = "_6c-3";
export var icon = "_6c-6";
export var input = "_6c-0";
export var labelSpacer = "_6c-8";
export var medium = "_6c-5";
export var small = "_6c-4";
export var text = "_6c-7";